import React, {useState } from "react";
import { Box, Flex, Text } from "@chakra-ui/react";
import { css } from "@emotion/react";
import { Link } from "react-router-dom";
import Icon from "../../component/constant/Icon";
const style = {
  mainSidebarBox: {
    width: "300px",
    height: "100%",
    background: "#f3ffe1",
    paddingTop: "40px",
  },

  sidebarText: {
    color: "#404040",
    fontFamily: "Inter",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: "normal",
    letterSpacing: "0.42px",
  },
  selected: {
    background: "#52771A",
    color: "#f3ffe1",
    fontFamily: "Inter",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: "normal",
    letterSpacing: "0.42px",
  },
};
const iconStyles = css`
  width: 20px;
  height: 20px;
  fill: #404040;
`;

const containerStyles = css`
  display: flex;
  width: 262px;
  padding: 12px 29px 12px 24px;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
  // border: 1px solid black;
  border-radius: 10px;
  background: #f3ffe1;
  cursor: pointer;
  transition: background-color 0.2s ease;
  &:hover {
    background-color: #d7faa3;
  }
`;

const Sidebar = () => {
  const [selectedItem, setSelectedItem] = useState(null);
  const handleItemClick = (index) => {
    setSelectedItem(index);
  };
  return (
    <Box style={style.mainSidebarBox}>
      <Box ml="4">
      <Link to={"/dashboard"}>
        <Flex
          align="center"
          css={containerStyles}
          style={selectedItem === 1 ? style.selected : style.sidebarText}
          onClick={() => handleItemClick(1)}
        >
          <Box as="svg" xmlns="http://www.w3.org/2000/svg" css={iconStyles}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
            >
              <path
                d="M18.3333 7.09999V3.31666C18.3333 2.14166 17.8 1.66666 16.475 1.66666H13.1083C11.7833 1.66666 11.25 2.14166 11.25 3.31666V7.09166C11.25 8.27499 11.7833 8.74166 13.1083 8.74166H16.475C17.8 8.74999 18.3333 8.27499 18.3333 7.09999Z"
                fill={selectedItem === 1 ? "#FFFFFF" : "#404040"}
              />
              <path
                d="M18.3333 16.475V13.1083C18.3333 11.7833 17.8 11.25 16.475 11.25H13.1083C11.7833 11.25 11.25 11.7833 11.25 13.1083V16.475C11.25 17.8 11.7833 18.3333 13.1083 18.3333H16.475C17.8 18.3333 18.3333 17.8 18.3333 16.475Z"
                fill={selectedItem === 1 ? "#FFFFFF" : "#404040"}
              />
              <path
                d="M8.75033 7.09999V3.31666C8.75033 2.14166 8.21699 1.66666 6.89199 1.66666H3.52533C2.20033 1.66666 1.66699 2.14166 1.66699 3.31666V7.09166C1.66699 8.27499 2.20033 8.74166 3.52533 8.74166H6.89199C8.21699 8.74999 8.75033 8.27499 8.75033 7.09999Z"
                fill={selectedItem === 1 ? "#FFFFFF" : "#404040"}
              />
              <path
                d="M8.75033 16.475V13.1083C8.75033 11.7833 8.21699 11.25 6.89199 11.25H3.52533C2.20033 11.25 1.66699 11.7833 1.66699 13.1083V16.475C1.66699 17.8 2.20033 18.3333 3.52533 18.3333H6.89199C8.21699 18.3333 8.75033 17.8 8.75033 16.475Z"
                fill={selectedItem === 1 ? "#FFFFFF" : "#404040"}
              />
            </svg>
          </Box>
          <Text style={selectedItem === 1 ? style.selected : style.sidebarText}>
            Dashboard
          </Text>
        </Flex>
        </Link>



        <Link to={"/OrderPageAdmin"}>
          <Flex
            align="center"
            css={containerStyles}
            style={selectedItem === 2 ? style.selected : style.sidebarText}
            onClick={() => handleItemClick(2)}
          >
            <Box as="svg" xmlns="http://www.w3.org/2000/svg" css={iconStyles}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="19"
                height="18"
                viewBox="0 0 19 18"
                fill="none"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M15.6672 3.85937H12.96V2.9378C12.96 1.30574 11.6351 0.000205088 10.0224 0.000205088H8.23686C6.60479 -0.0189466 5.27999 1.30574 5.27999 2.91864V3.8402H2.57276C1.15193 3.8402 0 4.99227 0 6.41297V8.65936C0.844833 8.90901 1.99673 9.1778 3.5328 9.389V9.33141C3.5328 8.44814 4.24316 7.73781 5.12639 7.73781H6.02879C6.91206 7.73781 7.62239 8.44817 7.62239 9.33141V9.67694C8.10239 9.69609 8.60155 9.69609 9.11999 9.69609C9.63842 9.69609 10.1376 9.69609 10.5984 9.67694V9.33141C10.5984 8.44814 11.3088 7.73781 12.192 7.73781H13.0944C13.9777 7.73781 14.688 8.44817 14.688 9.33141L14.6879 9.40815C16.2239 9.21609 17.3758 8.94732 18.2207 8.67852L18.2208 6.43226C18.24 4.99226 17.0879 3.85935 15.6672 3.85935V3.85937ZM7.48802 3.85937V2.9378C7.48802 2.53453 7.81441 2.20817 8.21766 2.20817H10.0032C10.4065 2.20817 10.7328 2.53455 10.7328 2.9378V3.85937H7.48802Z"
                  fill={selectedItem === 2 ? "#FFFFFF" : "#404040"}
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M14.7075 11.2706C14.7075 12.1538 13.9972 12.8642 13.1139 12.8642H12.2116C11.3283 12.8642 10.618 12.1538 10.618 11.2706V10.8866C10.138 10.9057 9.63879 10.9057 9.13952 10.9057C8.62109 10.9057 8.12192 10.9057 7.64192 10.8866V11.2706C7.64192 12.1538 6.93156 12.8642 6.04832 12.8642H5.14592C4.26266 12.8642 3.55233 12.1538 3.55233 11.2706V10.5985C2.07389 10.4064 0.921964 10.1761 0.0195312 9.92642V14.7456C0.0195312 16.1665 1.1716 17.3184 2.59229 17.3184H15.6867C17.1075 17.3184 18.2594 16.1663 18.2594 14.7456V9.90756C17.357 10.1572 16.205 10.4067 14.7266 10.5796V11.2707L14.7075 11.2706Z"
                  fill={selectedItem === 2 ? "#FFFFFF" : "#404040"}
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M6.02889 11.693C6.25925 11.693 6.45129 11.5009 6.45129 11.2706V9.35057C6.45129 9.12021 6.25923 8.92816 6.02889 8.92816H5.1265C4.89614 8.92816 4.7041 9.12022 4.7041 9.35057V11.2706C4.7041 11.5009 4.89615 11.693 5.1265 11.693H6.02889Z"
                  fill={selectedItem === 2 ? "#FFFFFF" : "#404040"}
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M13.1139 11.693C13.3442 11.693 13.5363 11.5009 13.5363 11.2706V9.35057C13.5363 9.12021 13.3442 8.92816 13.1139 8.92816H12.2115C11.9811 8.92816 11.7891 9.12022 11.7891 9.35057V11.2706C11.7891 11.5009 11.9811 11.693 12.2115 11.693H13.1139Z"
                  fill={selectedItem === 2 ? "#FFFFFF" : "#404040"}
                />
              </svg>
            </Box>
            <Text
              style={selectedItem === 2 ? style.selected : style.sidebarText}
            >
              Orders
            </Text>
          </Flex>
        </Link>
        <Link to={"/products"}>
          <Flex
            align="center"
            css={containerStyles}
            style={selectedItem === 3 ? style.selected : style.sidebarText}
            onClick={() => handleItemClick(3)}
          >
            <Box as="svg" xmlns="http://www.w3.org/2000/svg" css={iconStyles}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 30 30"
                fill="none"
              >
                <path
                  d="M10.9042 2.10001L20.8042 3.51401L22.2182 13.414L13.0252 22.606C12.8377 22.7935 12.5834 22.8988 12.3182 22.8988C12.0531 22.8988 11.7988 22.7935 11.6112 22.606L1.71123 12.706C1.52407 12.5185 1.41895 12.2644 1.41895 11.9995C1.41895 11.7346 1.52407 11.4805 1.71123 11.293L10.9042 2.10001ZM13.7332 10.585C13.9177 10.776 14.1384 10.9284 14.3824 11.0332C14.6264 11.138 14.8889 11.1932 15.1544 11.1955C15.42 11.1978 15.6833 11.1472 15.9291 11.0466C16.1749 10.9461 16.3982 10.7976 16.586 10.6098C16.7738 10.422 16.9223 10.1987 17.0229 9.95291C17.1234 9.70712 17.174 9.44376 17.1717 9.1782C17.1694 8.91265 17.1143 8.65021 17.0094 8.4062C16.9046 8.16219 16.7523 7.9415 16.5612 7.75701C16.184 7.39269 15.6788 7.1911 15.1544 7.19566C14.63 7.20021 14.1284 7.41055 13.7576 7.78137C13.3868 8.15219 13.1764 8.65381 13.1719 9.1782C13.1673 9.7026 13.3689 10.2078 13.7332 10.585Z"
                  fill={selectedItem === 3 ? "#FFFFFF" : "#404040"}
                />
              </svg>
            </Box>
            <Text
              style={selectedItem === 3 ? style.selected : style.sidebarText}
            >
              Products
            </Text>
          </Flex>
        </Link>
        <Link to={"/addproduct"}>
          <Flex
            align="center"
            css={containerStyles}
            style={selectedItem === 4 ? style.selected : style.sidebarText}
            onClick={() => handleItemClick(4)}
          >
            <Box as="svg" xmlns="http://www.w3.org/2000/svg" css={iconStyles}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M3.00488 7L11.4499 1.37C11.6142 1.26036 11.8073 1.20185 12.0049 1.20185C12.2024 1.20185 12.3956 1.26036 12.5599 1.37L21.0049 7V21C21.0049 21.2652 20.8995 21.5196 20.712 21.7071C20.5245 21.8946 20.2701 22 20.0049 22H4.00488C3.73967 22 3.48531 21.8946 3.29778 21.7071C3.11024 21.5196 3.00488 21.2652 3.00488 21V7ZM12.0049 11C12.5353 11 13.044 10.7893 13.4191 10.4142C13.7942 10.0391 14.0049 9.53043 14.0049 9C14.0049 8.46957 13.7942 7.96086 13.4191 7.58579C13.044 7.21071 12.5353 7 12.0049 7C11.4745 7 10.9657 7.21071 10.5907 7.58579C10.2156 7.96086 10.0049 8.46957 10.0049 9C10.0049 9.53043 10.2156 10.0391 10.5907 10.4142C10.9657 10.7893 11.4745 11 12.0049 11ZM8.00488 16V18H16.0049V16H8.00488ZM8.00488 13V15H16.0049V13H8.00488Z"
                  fill={selectedItem === 4 ? "#FFFFFF" : "#404040"}
                />
              </svg>
            </Box>
            <Text
              style={selectedItem === 4 ? style.selected : style.sidebarText}
            >
              Add Products
            </Text>
          </Flex>
        </Link>
        <Link to={"/addcategory"}>
          <Flex
            align="center"
            css={containerStyles}
            style={selectedItem === 5 ? style.selected : style.sidebarText}
            onClick={() => handleItemClick(5)}
          >
            <Box as="svg" xmlns="http://www.w3.org/2000/svg" css={iconStyles}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="21"
                height="21"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M21.75 7.5H18V9H21.75V13.5H16.5V15H18.75V16.6065C18.043 16.789 17.4269 17.2232 17.017 17.8275C16.6072 18.4318 16.4319 19.1649 16.5239 19.8893C16.6159 20.6136 16.9689 21.2795 17.5168 21.7622C18.0647 22.2449 18.7698 22.5112 19.5 22.5112C20.2302 22.5112 20.9353 22.2449 21.4832 21.7622C22.0311 21.2795 22.3841 20.6136 22.4761 19.8893C22.5681 19.1649 22.3928 18.4318 21.983 17.8275C21.5731 17.2232 20.957 16.789 20.25 16.6065V15H21.75C22.1476 14.9994 22.5288 14.8412 22.81 14.56C23.0912 14.2788 23.2494 13.8976 23.25 13.5V9C23.2496 8.6023 23.0914 8.221 22.8102 7.93978C22.529 7.65856 22.1477 7.5004 21.75 7.5ZM21 19.5C21 19.7967 20.912 20.0867 20.7472 20.3334C20.5824 20.58 20.3481 20.7723 20.074 20.8858C19.7999 20.9994 19.4983 21.0291 19.2074 20.9712C18.9164 20.9133 18.6491 20.7704 18.4393 20.5607C18.2296 20.3509 18.0867 20.0836 18.0288 19.7926C17.9709 19.5017 18.0006 19.2001 18.1142 18.926C18.2277 18.6519 18.42 18.4176 18.6666 18.2528C18.9133 18.088 19.2033 18 19.5 18C19.8976 18.0006 20.2788 18.1588 20.56 18.44C20.8412 18.7212 20.9994 19.1024 21 19.5ZM14.25 4.5H10.5V6H14.25V10.5H9V12H11.25V16.6065C10.543 16.789 9.92686 17.2232 9.51705 17.8275C9.10724 18.4318 8.9319 19.1649 9.02391 19.8893C9.11592 20.6136 9.46895 21.2795 10.0168 21.7622C10.5647 22.2449 11.2698 22.5112 12 22.5112C12.7302 22.5112 13.4353 22.2449 13.9832 21.7622C14.5311 21.2795 14.8841 20.6136 14.9761 19.8893C15.0681 19.1649 14.8928 18.4318 14.483 17.8275C14.0731 17.2232 13.457 16.789 12.75 16.6065V12H14.25C14.6477 11.9996 15.029 11.8414 15.3102 11.5602C15.5914 11.279 15.7496 10.8977 15.75 10.5V6C15.7496 5.6023 15.5914 5.221 15.3102 4.93978C15.029 4.65856 14.6477 4.5004 14.25 4.5ZM13.5 19.5C13.5 19.7967 13.412 20.0867 13.2472 20.3334C13.0824 20.58 12.8481 20.7723 12.574 20.8858C12.2999 20.9994 11.9983 21.0291 11.7074 20.9712C11.4164 20.9133 11.1491 20.7704 10.9393 20.5607C10.7296 20.3509 10.5867 20.0836 10.5288 19.7926C10.4709 19.5017 10.5006 19.2001 10.6142 18.926C10.7277 18.6519 10.92 18.4176 11.1666 18.2528C11.4133 18.088 11.7033 18 12 18C12.3976 18.0006 12.7788 18.1588 13.06 18.44C13.3412 18.7212 13.4994 19.1024 13.5 19.5ZM6.75 1.5H2.25C1.8523 1.5004 1.471 1.65856 1.18978 1.93978C0.90856 2.221 0.750397 2.6023 0.75 3V7.5C0.750397 7.8977 0.90856 8.279 1.18978 8.56022C1.471 8.84144 1.8523 8.9996 2.25 9H3.75V16.6065C3.04301 16.789 2.42686 17.2232 2.01705 17.8275C1.60724 18.4318 1.43191 19.1649 1.52391 19.8893C1.61592 20.6136 1.96895 21.2795 2.51683 21.7622C3.06471 22.2449 3.76982 22.5112 4.5 22.5112C5.23018 22.5112 5.9353 22.2449 6.48317 21.7622C7.03105 21.2795 7.38408 20.6136 7.47609 19.8893C7.56809 19.1649 7.39276 18.4318 6.98295 17.8275C6.57314 17.2232 5.95699 16.789 5.25 16.6065V9H6.75C7.1477 8.9996 7.529 8.84144 7.81022 8.56022C8.09144 8.279 8.2496 7.8977 8.25 7.5V3C8.2496 2.6023 8.09144 2.221 7.81022 1.93978C7.529 1.65856 7.1477 1.5004 6.75 1.5ZM6 19.5C6 19.7967 5.91203 20.0867 5.7472 20.3334C5.58238 20.58 5.34811 20.7723 5.07403 20.8858C4.79994 20.9994 4.49834 21.0291 4.20736 20.9712C3.91639 20.9133 3.64912 20.7704 3.43934 20.5607C3.22956 20.3509 3.0867 20.0836 3.02882 19.7926C2.97094 19.5017 3.00065 19.2001 3.11418 18.926C3.22771 18.6519 3.41997 18.4176 3.66664 18.2528C3.91332 18.088 4.20333 18 4.5 18C4.8977 18.0004 5.279 18.1586 5.56022 18.4398C5.84144 18.721 5.9996 19.1023 6 19.5ZM2.25 7.5V3H6.75L6.7515 7.5H2.25Z"
                  fill={selectedItem === 5 ? "#FFFFFF" : "#404040"}
                />
              </svg>
            </Box>
            <Text
              style={selectedItem === 5 ? style.selected : style.sidebarText}
            >
              Category
            </Text>
          </Flex>
        </Link>
        <Link to={"/addsubcategory"}>
          <Flex
            align="center"
            css={containerStyles}
            style={selectedItem === 6 ? style.selected : style.sidebarText}
            onClick={() => handleItemClick(6)}
          >
            <Box as="svg" xmlns="http://www.w3.org/2000/svg" css={iconStyles}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="22"
                height="22"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M7.425 9.475L11.15 3.4C11.25 3.23333 11.375 3.11233 11.525 3.037C11.675 2.96167 11.8333 2.92433 12 2.925C12.1667 2.925 12.325 2.96267 12.475 3.038C12.625 3.11333 12.75 3.234 12.85 3.4L16.575 9.475C16.675 9.64167 16.725 9.81667 16.725 10C16.725 10.1833 16.6833 10.35 16.6 10.5C16.5167 10.65 16.4 10.771 16.25 10.863C16.1 10.955 15.925 11.0007 15.725 11H8.275C8.075 11 7.9 10.954 7.75 10.862C7.6 10.77 7.48334 10.6493 7.4 10.5C7.31667 10.35 7.275 10.1833 7.275 10C7.275 9.81667 7.325 9.64167 7.425 9.475ZM17.5 22C16.25 22 15.1873 21.5623 14.312 20.687C13.4367 19.8117 12.9993 18.7493 13 17.5C13 16.25 13.4377 15.1873 14.313 14.312C15.1883 13.4367 16.2507 12.9993 17.5 13C18.75 13 19.8127 13.4377 20.688 14.313C21.5633 15.1883 22.0007 16.2507 22 17.5C22 18.75 21.5623 19.8127 20.687 20.688C19.8117 21.5633 18.7493 22.0007 17.5 22ZM3 20.5V14.5C3 14.2167 3.096 13.979 3.288 13.787C3.48 13.595 3.71734 13.4993 4 13.5H10C10.2833 13.5 10.521 13.596 10.713 13.788C10.905 13.98 11.0007 14.2173 11 14.5V20.5C11 20.7833 10.904 21.021 10.712 21.213C10.52 21.405 10.2827 21.5007 10 21.5H4C3.71667 21.5 3.479 21.404 3.287 21.212C3.095 21.02 2.99934 20.7827 3 20.5ZM17.5 20C18.2 20 18.7917 19.7583 19.275 19.275C19.7583 18.7917 20 18.2 20 17.5C20 16.8 19.7583 16.2083 19.275 15.725C18.7917 15.2417 18.2 15 17.5 15C16.8 15 16.2083 15.2417 15.725 15.725C15.2417 16.2083 15 16.8 15 17.5C15 18.2 15.2417 18.7917 15.725 19.275C16.2083 19.7583 16.8 20 17.5 20ZM5 19.5H9V15.5H5V19.5ZM10.05 9H13.95L12 5.85L10.05 9Z"
                  fill={selectedItem === 6 ? "#FFFFFF" : "#404040"}
                />
              </svg>
            </Box>
            <Text
              style={selectedItem === 6 ? style.selected : style.sidebarText}
            >
              Sub Category
            </Text>
          </Flex>
        </Link>
        <Link to={"/addservice"}>
          <Flex
            align="center"
            css={containerStyles}
            style={selectedItem === 7 ? style.selected : style.sidebarText}
            onClick={() => handleItemClick(7)}
          >
            <Box as="svg" xmlns="http://www.w3.org/2000/svg" css={iconStyles}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="21"
                height="20"
                viewBox="0 0 21 20"
                fill="none"
              >
                <path
                  d="M20.9 17.2L16.8 13.1C17.2 12.1 17 10.8 16.1 10C15.2 9.1 13.9 8.9 12.8 9.4L14.7 11.3L13.3 12.7L11.3 10.7C10.8 11.8 11 13.1 11.9 14.1C12.8 15 14 15.2 15 14.8L19.1 18.9C19.3 19.1 19.6 19.1 19.7 18.9L20.7 17.9C21 17.6 21 17.3 20.9 17.2ZM11 16H0V14C0 11.8 3.6 10 8 10C8.5 10 9 10 9.4 10.1C9.1 10.7 9 11.3 9 12C9 13.6 9.8 15.1 11 16ZM8 0C5.8 0 4 1.8 4 4C4 6.2 5.8 8 8 8C10.2 8 12 6.2 12 4C12 1.8 10.2 0 8 0Z"
                  fill={selectedItem === 7 ? "#FFFFFF" : "#404040"}
                />
              </svg>
            </Box>
            <Text
              style={selectedItem === 7 ? style.selected : style.sidebarText}
            >
              Services
            </Text>
          </Flex>
        </Link>

        <Link to={"/addgovermentschme"}>
          <Flex
            align="center"
            css={containerStyles}
            style={selectedItem === 8 ? style.selected : style.sidebarText}
            onClick={() => handleItemClick(8)}
          >
            <Box as="svg" xmlns="http://www.w3.org/2000/svg" css={iconStyles}>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M2 19V8H1V6H4V4C4 3.73478 4.10536 3.48043 4.29289 3.29289C4.48043 3.10536 4.73478 3 5 3H19C19.2652 3 19.5196 3.10536 19.7071 3.29289C19.8946 3.48043 20 3.73478 20 4V6H23V8H22V19H23V21H1V19H2ZM13 19V12H11V19H13ZM8 19V12H6V19H8ZM18 19V12H16V19H18ZM6 5V6H18V5H6Z"
                  fill={selectedItem === 8 ? "#FFFFFF" : "#404040"}
                />
              </svg>
            </Box>
            <Text
              style={selectedItem === 8 ? style.selected : style.sidebarText}
            >
              Goverment Schme
            </Text>
          </Flex>
        </Link>

        
        <Link to={"/customers"}>
          <Flex
            align="center"
            css={containerStyles}
            style={selectedItem === 9 ? style.selected : style.sidebarText}
            onClick={() => handleItemClick(9)}
          >
           <Icon type={"CUSTOMER"} color={selectedItem === 9 ? "#FFFFFF" : "#404040" } size={24}/>
            <Text
              style={selectedItem === 9 ? style.selected : style.sidebarText}
            >
              Customers
            </Text>
          </Flex>
        </Link>
      </Box>
    </Box>
  );
};

export default Sidebar;
